module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Avans_image_5.50e9e062.jpg";